import React from 'react';
import { ArrowRight, Github, Linkedin, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { portfolioData } from '../data/mock';

const HeroSection = () => {
  const { personal } = portfolioData;

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 pt-16">
      <div className="max-w-5xl mx-auto text-center">
        <div className="mb-6">
          <div className="flex justify-center mb-8">
            <div className="relative">
              <img
                src={personal.profilePhoto}
                alt="Tilakraj Desai - Tilak - Lead DevOps Engineer"
                className="w-32 h-32 sm:w-40 sm:h-40 rounded-full object-cover border-4 border-emerald-500 shadow-lg shadow-emerald-500/20"
              />
              <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-emerald-500/20 to-transparent"></div>
            </div>
          </div>
          <p className="text-emerald-400 font-mono text-sm mb-4">Hi, I'm Tilak</p>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-4">
            {personal.name}
          </h1>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-400 mb-6">
            {personal.title}
          </h2>
          <p className="text-lg sm:text-xl text-gray-400 max-w-2xl mx-auto mb-8">
            {personal.tagline}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <Button
            onClick={scrollToContact}
            className="bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-6 text-lg rounded-md transition-all duration-300 hover:shadow-lg hover:shadow-emerald-500/50"
          >
            Get In Touch
            <ArrowRight className="ml-2" size={20} />
          </Button>
          <Button
            variant="outline"
            className="border-2 border-emerald-500 text-emerald-400 hover:bg-emerald-500/10 px-8 py-6 text-lg rounded-md transition-all duration-300"
            onClick={() => {
              const element = document.getElementById('projects');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            View Projects
          </Button>
        </div>

        <div className="flex flex-col items-center gap-6">
          <div className="flex items-center justify-center gap-6">
            <a
              href={personal.linkedIn}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-emerald-400 transition-colors duration-300"
            >
              <Linkedin size={24} />
            </a>
            <a
              href={`mailto:${personal.email}`}
              className="text-gray-400 hover:text-emerald-400 transition-colors duration-300"
            >
              <Mail size={24} />
            </a>
          </div>
          
          <a
            href="https://tools.tilakraj.cv"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-500 hover:text-emerald-400 transition-colors duration-300 border border-gray-700 hover:border-emerald-500 px-4 py-2 rounded-md"
          >
            DevOps Tools I Use → tools.tilakraj.cv
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
